<h1 matDialogTitle>Rechnungsdatei wird generiert</h1>
<mat-dialog-content>
    <ng-container *ngIf="loading$ | async">
        <p>Die PDF-Datei wird im Hintergrund generiert.</p>
        <p>Bitte warten Sie oder kommen Sie später wieder.</p>
        <app-loading></app-loading>
    </ng-container>
    <p *ngIf="failed$ | async">Die PDF-Datei konnte nicht generiert werden.</p>
    <p *ngIf="none$ | async">Die PDF-Datei generierung wurde nicht gestartet.</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button Color="cancel" Inverted [matDialogClose]="undefined">schließen</button>
</mat-dialog-actions>
